// extracted by mini-css-extract-plugin
export default {"waitlistTooltipWrapper":"VisitWaitlistToggle_waitlistTooltipWrapper__CvC86","waitlistInfoIcon":"VisitWaitlistToggle_waitlistInfoIcon__0SpRK","sro":"VisitWaitlistToggle_sro__j1IL8"};